import { useState } from 'react';
import { Button, Group, Modal, Stack, TextInput } from '@buildex/ui';
import { ColorInput } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $tenantCreating, tenantCreateSubmitted } from '@/entities/tenant/model';

interface CreateTenantModalProps {
  opened: boolean;
  onClose: () => void;
}

export function CreateTenantModal({ opened, onClose }: CreateTenantModalProps) {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [primaryColor, setPrimaryColor] = useState('#1971c2');
  const [creating, submit] = useUnit([$tenantCreating, tenantCreateSubmitted]);

  const onSubmit = () => {
    if (!name || !slug) return;
    submit({ name, slug: slug.toLowerCase(), primaryColor });
    setName('');
    setSlug('');
    onClose();
  };

  return (
    <Modal opened={opened} onClose={onClose} title={t('tenants.createTitle')}>
      <Stack gap="sm">
        <TextInput
          label={t('tenants.name')}
          required
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
        />
        <TextInput
          label={t('tenants.slugLabel')}
          description={t('tenants.slugHint')}
          required
          value={slug}
          onChange={(e) => setSlug(e.currentTarget.value)}
          rightSectionWidth={110}
          rightSection={<span style={{ fontSize: 12, color: 'var(--mantine-color-dimmed)' }}>.buildex.com</span>}
        />
        <ColorInput
          label={t('tenants.primaryColor')}
          value={primaryColor}
          onChange={setPrimaryColor}
        />
        <Group justify="flex-end" mt="sm">
          <Button variant="default" onClick={onClose}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onSubmit} loading={creating} disabled={!name || !slug}>
            {t('common.create')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
